import { IonButton, IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonRow, IonTitle, IonToast, IonToolbar, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { alertCircle, arrowBack, informationCircleOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { apiPedidosCaixaGeralLancamentosGET, apiPedidosCaixasGET, apiPedidosCaixasLancamentoPOST, apiPedidosCaixasPUT, mesaGerarCupom, projetoGerarCupom, requestService } from '../../../../../Utils/Services';
import CaixaGeralAbrir from '../CaixaGeralAbrir/CaixaGeralAbrir';
import './CaixaGeral.css';

const CaixaGeral: React.FC = () => {

  const history = useHistory();
  const [itens, setItens] = useState<any>([]);
  const [stateResultadoMesas, setStateResultadoMesas] = useState<any>([]);
  const [stateResultadoBalcao, setStateResultadoBalcao] = useState<any>([]);
  const [stateResultadoOrdens, setStateResultadoOrdens] = useState<any>([]);
  const [stateResultadoTotem, setStateResultadoTotem] = useState<any>([]);
  const [stateTotal, setStateTotal] = useState<number>(0);
  const [stateTotalBalcao, setStateTotalBalcao] = useState<number>(0);
  const [stateTotalMesa, setStateTotalMesa] = useState<number>(0);
  const [stateTotalOrdens, setStateTotalOrdens] = useState<number>(0);
  const [stateTotalTotem, setStateTotalTotem] = useState<number>(0);
  const [stateDinheiro, setStateDinheiro] = useState<number>(0);
  // const [stateCartaoCredito, setStateCartaoCredito] = useState<number>(0);
  // const [stateCartaoDebito, setStateCartaoDebito] = useState<number>(0);
  // const [statePix, setStatePix] = useState<number>(0);
  // const [stateAlelo, setStateAlelo] = useState<number>(0);
  // const [stateSodexo, setStateSodexo] = useState<number>(0);
  // const [stateValeAlimentacao, setStateValeAlimentacao] = useState<number>(0);
  // const [stateBoleto, setStateBoleto] = useState<number>(0);
  // const [stateSemDefinicao, setStateSemDefinicao] = useState<number>(0);
  const [stateCaixas, setStateCaixas] = useState<any>([]);
  const [stateCaixaSelecionado, setStateCaixaSelecionado] = useState<any>({});

  const [statePagamentos, setStatePagamentos] = useState<{ [key: string]: number }>({});
  const [stateLancamentos, setStateLancamentos] = useState<any[]>([]);
  const [stateSaldoLancamentos, setStateSaldoLancamentos] = useState<number>(0);

  const [mostartAlerta] = useIonAlert();
  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [caixaAberto, setCaixaAberto] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);

  const [showModal, setShowModal] = useState(false);

  // Loading State
  const [showLoading, setShowLoading] = useState(false);

  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));

  const [showModalDetalhes, setShowModalDetalhes] = useState(false);
  const [showModalEntrada, setShowModalEntrada] = useState(false);
  const [showModalSaida, setShowModalSaida] = useState(false);
  const [showModalLancamentos, setShowModalLancamentos] = useState(false);

  // Estados para Modal Entrada
  const [valorEntrada, setValorEntrada] = useState<string>('');
  const [descricaoEntrada, setDescricaoEntrada] = useState<string>('');
  const [alertaValorEntrada, setAlertaValorEntrada] = useState(false);
  const [alertaDescricaoEntrada, setAlertaDescricaoEntrada] = useState(false);

  // Estados para Modal Saída
  const [valorSaida, setValorSaida] = useState<string>('');
  const [descricaoSaida, setDescricaoSaida] = useState<string>('');
  const [alertaValorSaida, setAlertaValorSaida] = useState(false);
  const [alertaDescricaoSaida, setAlertaDescricaoSaida] = useState(false);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarCaixas();
  });

  function carregarCaixas() {
    return requestService(
      apiPedidosCaixasGET.url.replace("{id}", loja.replaceAll("#", "%23")),
      {
        method: apiPedidosCaixasGET.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        if (response) {
          setStateCaixas(response);
          //console.log('getCaixas', response);
          if (response.Items[0]) {
            setStateCaixaSelecionado(response.Items[0]);
            carregarCaixaGeral(response.Items[0].sk);
          }
        }
      },
      (error: any) => {
        console.log(error);
      }
    )
  };

  function carregarCaixaGeral(filtro: any = null) {
    return requestService(
      apiPedidosCaixaGeralLancamentosGET.url.replace("{id}", loja.replaceAll("#", "%23")).concat(filtro ? "?caixa=".concat(Buffer.from(filtro).toString('base64')) : ""),
      {
        method: apiPedidosCaixaGeralLancamentosGET.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        if (response) {
          setItens(response.items);
          setStateResultadoMesas(response.retComanda);
          setStateResultadoBalcao(response.retBalcao);
          setStateResultadoOrdens(response.retOrdens);
          setStateResultadoTotem(response.retTotem);
          setStateTotal(response.total);
          setStateTotalBalcao(response.totalBalcao);
          setStateTotalMesa(response.totalMesa);
          setStateTotalOrdens(response.totalOrdens);
          setStateTotalTotem(response.totalTotem);

          // Processa lançamentos (entradas e saídas) do retCaixa
          const retCaixa = response.retCaixa || {};
          const lancamentos = retCaixa.lancamentos || [];

          // Calcula o saldo dos lançamentos (entrada - saída)
          const saldo = lancamentos.reduce((acc: number, lancamento: any) => {
            return acc + lancamento.valor;
          }, 0);

          setStateLancamentos(lancamentos);
          setStateSaldoLancamentos(saldo);

          // setStateDinheiro(response.dinheiro);
          // setStateCartaoCredito(response.cartaoCredito);
          // setStateCartaoDebito(response.cartaoDebito);
          // setStatePix(response.pix);
          // setStateAlelo(response.alelo);
          // setStateSodexo(response.sodexo);
          // setStateValeAlimentacao(response.valeAlimentacao);
          // setStateBoleto(response.boleto);

          // console.log("boleto", response.boleto);
          // setStateSemDefinicao(response.semDefinicao);

          const pagamentos = response.totaisPorFormaDePagamento || {};

          console.log("pagamentos", pagamentos);

          const novoEstadoPagamentos: { [key: string]: number } = {};

          // Itera sobre as entradas do objeto e constrói o estado
          Object.entries(pagamentos).forEach(([nome, valor]) => {
            const valorNumerico = Number(valor);
            novoEstadoPagamentos[nome] = valorNumerico;

            // Verifica se o nome (em lowercase) é "dinheiro"
            if (nome.toLowerCase() === "dinheiro") {
              setStateDinheiro(valorNumerico);
            }
          });

          setStatePagamentos(novoEstadoPagamentos);

        }
      },
      (error: any) => {
        console.log(error);
      }
    )
  };

  const mensagemFecharCaixa = () => {
    mostartAlerta({
      backdropDismiss: false,
      header: "Atenção!",
      message: "Você tem certeza que deseja fechar o caixa?",
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {

          }
        },
        {
          text: 'Confirmar',
          handler: async () => {


            fecharCaixa();

          }
        }
      ],
      onDidDismiss: () => { console.log('did dismiss'); }
    });
  };

  const fecharCaixa = () => {
    setShowLoading(true);

    let objRequest = {
      loja: loja,
      pk: stateCaixaSelecionado.pk,
      sk: stateCaixaSelecionado.sk,
    }

    requestService(
      apiPedidosCaixasPUT.url.replace("{id}", loja.replaceAll("#", "%23")),
      {
        method: apiPedidosCaixasPUT.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        if (response.message && response.message.Attributes) {
          carregarCaixas();
        }
      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message);
        setShowToast(true);
      }
    ).finally(() => {
      setShowLoading(false);
    });
  };

  function onChangeValorEntrada(e: any) {
    e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    setValorEntrada(v);
    setAlertaValorEntrada(false);
  }

  function onChangeValorSaida(e: any) {
    e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    setValorSaida(v);
    setAlertaValorSaida(false);
  }

  const salvarEntrada = () => {
    let hasError = false;

    // Converte o valor formatado para número
    const valorNumerico = parseFloat(valorEntrada.replace(/\./g, '').replace(',', '.'));

    if (!valorEntrada || isNaN(valorNumerico) || valorNumerico <= 0) {
      setAlertaValorEntrada(true);
      hasError = true;
    } else {
      setAlertaValorEntrada(false);
    }

    if (!descricaoEntrada.trim()) {
      setAlertaDescricaoEntrada(true);
      hasError = true;
    } else {
      setAlertaDescricaoEntrada(false);
    }

    if (hasError) {
      return;
    }

    setShowLoading(true);

    const objRequest = {
      loja: loja,
      pk: stateCaixaSelecionado.pk,
      sk: stateCaixaSelecionado.sk,
      tipo: 'entrada',
      valor: valorNumerico,
      descricao: descricaoEntrada.trim()
    };

    requestService(
      apiPedidosCaixasLancamentoPOST.url.replace("{id}", loja.replaceAll("#", "%23")),
      {
        method: apiPedidosCaixasLancamentoPOST.method,
        headers: [["token", window.localStorage.getItem("token")]],
        body: JSON.stringify(objRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        setShowModalEntrada(false);
        setValorEntrada('');
        setDescricaoEntrada('');
        setAlertaValorEntrada(false);
        setAlertaDescricaoEntrada(false);
        carregarCaixas();
        setShowLoading(false);
      },
      (error: any) => {
        setTextToast(error.message || 'Erro ao registrar entrada');
        setShowToast(true);
        setShowLoading(false);
      }
    );
  };

  const salvarSaida = () => {
    let hasError = false;

    // Converte o valor formatado para número
    const valorNumerico = parseFloat(valorSaida.replace(/\./g, '').replace(',', '.'));

    if (!valorSaida || isNaN(valorNumerico) || valorNumerico <= 0) {
      setAlertaValorSaida(true);
      hasError = true;
    } else {
      setAlertaValorSaida(false);
    }

    if (!descricaoSaida.trim()) {
      setAlertaDescricaoSaida(true);
      hasError = true;
    } else {
      setAlertaDescricaoSaida(false);
    }

    if (hasError) {
      return;
    }

    setShowLoading(true);

    const objRequest = {
      loja: loja,
      pk: stateCaixaSelecionado.pk,
      sk: stateCaixaSelecionado.sk,
      tipo: 'saida',
      valor: valorNumerico,
      descricao: descricaoSaida.trim()
    };

    requestService(
      apiPedidosCaixasLancamentoPOST.url.replace("{id}", loja.replaceAll("#", "%23")),
      {
        method: apiPedidosCaixasLancamentoPOST.method,
        headers: [["token", window.localStorage.getItem("token")]],
        body: JSON.stringify(objRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        setShowModalSaida(false);
        setValorSaida('');
        setDescricaoSaida('');
        setAlertaValorSaida(false);
        setAlertaDescricaoSaida(false);
        carregarCaixas();
        setShowLoading(false);
      },
      (error: any) => {
        setTextToast(error.message || 'Erro ao registrar saída');
        setShowToast(true);
        setShowLoading(false);
      }
    );
  };


  async function closeModal() {
    setShowModal(false);
  }

  async function closeModalSuccess() {
    carregarCaixas();
    setShowModal(false);
  }

  function readListaDetalhes() {
    return (
      <>
        {itens.map((value: any) => (
          <IonItem
            key={"detalhes" + value.pk}
            button
            detail={true}
            style={{ '--padding-start': '0', '--inner-padding-end': '0' }}
            onClick={() => {
              if (value.tipo === "projeto") {
                gerarCupomOrdens(value.pk);
              } else if (value.tipo === "caixa") {
                gerarCupom(value.pk);
              } else if (value.tipo === "comandas") {
                gerarCupom(value.pk);
              } else if (value.tipo === "totem") {
                gerarCupom(value.pk);
              }
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', padding: '8px 12px', width: '100%', gap: 8 }}>
              <div style={{ width: 80, flexShrink: 0, display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: 12, color: '#888' }}>
                  {value.dataCadastro ? new Date(value.dataCadastro).toLocaleDateString('pt-BR') : ''}
                </span>
                <span style={{ fontSize: 11, color: '#aaa' }}>
                  {value.dataCadastro ? new Date(value.dataCadastro).toLocaleTimeString('pt-BR') : ''}
                </span>
              </div>
              <span style={{ width: 52, flexShrink: 0, fontSize: 13, color: '#444' }}>
                {value.tipo === "caixa"
                  ? "Balcão"
                  : value.tipo === "projeto"
                    ? (window.localStorage.getItem("servicoTipoPlural") || "Projetos")
                    : value.tipo === "comandas"
                      ? (window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas")
                      : value.tipo === "totem"
                        ? "Totem"
                        : value.tipo.toUpperCase()}
              </span>
              <span style={{ flex: 1, fontSize: 13, color: '#222', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {value.clienteNome}
              </span>
              <span style={{ width: 76, flexShrink: 0, fontSize: 13, fontWeight: 600, color: 'var(--ion-color-success)', textAlign: 'right' }}>
                R$ {value.valorTotal?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>
          </IonItem>

        ))}
      </>
    );
  }


  async function gerarCupomOrdens(projetoid: any) {


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }
    console.log("projetoid", projetoid);

    try {
      setShowLoading(true);
      const resp = await fetch(projetoGerarCupom.url.replaceAll("{id}", projetoid.replaceAll(/#/g, "%23")),
        {
          method: projetoGerarCupom.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });
      const result = await resp.json();
      if (result) {
        console.log("result", result);

        mostartAlerta({
          backdropDismiss: false,
          header: 'Gerar Cupom',
          message: '<strong>Cupom</strong> foi gerado com sucesso.',
          buttons: [
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Visualizar',
              cssClass: 'primary',
              handler: () => {
                window.open(result, '_blank');
              }
            }
          ],
          onDidDismiss: (e) => console.log('did dismiss'),
        })

      }

    } catch (error) {
      console.error("Erro ao gerar cupom:", error);
      setTextToast("Ocorreu um erro ao encontrar o detalhe.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }

  }

  async function gerarCupom(comandaid: any) {
    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof tkn === "string") { token = tkn; }
    console.log("comandaid", comandaid);

    try {
      setShowLoading(true);
      const resp = await fetch(mesaGerarCupom.url.replaceAll("{id}", comandaid.replaceAll(/#/g, "%23")), {
        method: mesaGerarCupom.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
      const result = await resp.json();
      if (result) {
        console.log("result", result);

        mostartAlerta({
          backdropDismiss: false,
          header: 'Gerar Cupom',
          message: '<strong>Cupom</strong> foi gerado com sucesso.',
          buttons: [
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Visualizar',
              cssClass: 'primary',
              handler: () => {
                window.open(result, '_blank');
              }
            }
          ],
          onDidDismiss: (e) => console.log('did dismiss'),
        });
      }
    } catch (error) {
      console.error("Erro ao gerar cupom:", error);
      setTextToast("Ocorreu um erro ao encontrar o detalhe.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  }

  return (
    <IonPage>
      <IonHeader>

        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Caixa</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid>
          <IonRow>
            <IonCol size='12' sizeMd='4'>
              <IonItem lines='full' color='light'>
                <IonLabel>
                  <h1>Histórico</h1>
                  <p>Registro de caixas da empresa</p>
                </IonLabel>
              </IonItem>
              <div style={{ paddingTop: "10px" }}>
                <IonButton hidden={stateCaixas?.Items?.some((item: any) => item.status === 'aberto') || false}
                  disabled={acessos?.caixa != 'edicao'}
                  color='success'
                  expand='block'
                  size='large'
                  onClick={() => {
                    setShowModal(true);
                  }}>Quero abrir meu Caixa</IonButton>
              </div>
              <div style={{ paddingTop: "10px" }}>
                {
                  stateCaixas.Items && stateCaixas.Items.map((item: any) => {
                    return (
                      <IonItem key={item.sk} detail button lines='none'
                        color={item.sk === stateCaixaSelecionado.sk ? 'selected' : ''}
                        onClick={() => {
                          console.log("item", item);
                          carregarCaixaGeral(item.sk);
                          setStateCaixaSelecionado(item);
                        }}
                        style={{
                          // '--border-radius': '8px',
                          '--padding-start': '12px',
                          marginBottom: '4px',
                          borderLeft: `4px solid ${item.status === 'aberto' ? 'var(--ion-color-success)' : 'var(--ion-color-danger)'}`,
                        }}
                      >
                        <IonLabel>
                          <div style={{ fontWeight: 600, fontSize: 15 }}>
                            {new Date(item.dataAbertura).toLocaleDateString('pt-BR')}
                          </div>
                          <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                            {new Date(item.dataAbertura).toLocaleTimeString('pt-BR')}
                          </div>
                        </IonLabel>
                        <IonChip slot='end' color={item.status === 'fechado' ? 'danger' : 'success'} style={{ fontWeight: 600 }}>
                          {item.status}
                        </IonChip>
                      </IonItem>
                    );
                  })
                }
              </div>
            </IonCol>
            <IonCol size='12' sizeMd='8'>
              <IonItem lines='full' color='light' detail={true} onClick={() => {
                setShowModalDetalhes(true);
              }} button>
                <IonLabel>
                  <h1>Resumo do Caixa</h1>
                  <p>Acompanhamento do caixa da empresa</p>
                </IonLabel>
                <IonLabel style={{ margin: 0 }} slot='end'>detalhes</IonLabel>
              </IonItem>
              <div className='caixaGeralTabelaCaixa'>
                {/* <IonItem lines='none' hidden={true}>
                  <IonLabel><b>Ações no caixa</b></IonLabel>
                  <IonChip color='success'>
                    <IonLabel>Suprimento</IonLabel>
                    <IonIcon icon={addCircle}></IonIcon>
                  </IonChip>
                  <IonChip color='danger'>
                    <IonLabel>Sangria</IonLabel>
                    <IonIcon src={removeCircle}></IonIcon>
                  </IonChip>
                </IonItem> */}

                <div style={{ paddingTop: "10px" }}>
                  <IonGrid className='data'>
                    <IonRow>
                      <IonCol>Status</IonCol>
                      <IonCol size='8'><b>{stateCaixaSelecionado.status}</b></IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol>Abertura</IonCol>
                      <IonCol size='8'>{stateCaixaSelecionado.dataAbertura && new Date(stateCaixaSelecionado.dataAbertura).toLocaleString("en-GB")}</IonCol>
                    </IonRow>
                    <IonRow hidden={stateCaixaSelecionado.dataFechamento ? false : true}>
                      <IonCol>Fechamento</IonCol>
                      <IonCol size='8'>{stateCaixaSelecionado.dataFechamento && new Date(stateCaixaSelecionado.dataFechamento).toLocaleString("en-GB")}</IonCol>
                    </IonRow>
                  </IonGrid>




                  <IonGrid>
                    <IonRow>


                      <IonCol size="12" sizeMd="3">
                        <IonCard style={{ margin: "2px" }}

                        >

                          <IonCardContent>


                            <div style={{ fontSize: "14px" }}>
                              <IonLabel className="ion-text-wrap">
                                <b>Vendas</b>
                              </IonLabel>
                            </div>


                            <div style={{ fontSize: "20px" }}>
                              <IonLabel className="ion-text-wrap">
                                {"R$ " + Number(stateTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </IonLabel>
                            </div>


                          </IonCardContent>
                        </IonCard>
                      </IonCol>

                      <IonCol size="12" sizeMd="3">
                        <IonCard style={{ margin: "2px" }}

                        >

                          <IonCardContent>

                            <div style={{ fontSize: "14px" }}>
                              <IonLabel className="ion-text-wrap">
                                <b>Abertura</b>
                              </IonLabel>
                            </div>


                            <div style={{ fontSize: "20px" }}>
                              <IonLabel className="ion-text-wrap">
                                {"R$ " + Number(stateCaixaSelecionado.abertura || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </IonLabel>
                            </div>


                          </IonCardContent>
                        </IonCard>
                      </IonCol>

                      <IonCol size="12" sizeMd="3">
                        <IonCard style={{ margin: "2px" }}

                        >

                          <IonCardContent>

                            <div style={{ fontSize: "14px", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <IonLabel className="ion-text-wrap">
                                <b>Lançamentos</b>
                              </IonLabel>
                              <IonIcon
                                icon={informationCircleOutline}
                                style={{ fontSize: '22px', cursor: 'pointer', color: 'var(--ion-color-primary)' }}
                                onClick={() => setShowModalLancamentos(true)}
                              />
                            </div>


                            <div style={{ fontSize: "20px" }}>
                              <IonLabel className="ion-text-wrap">
                                {"R$ " + Number(stateSaldoLancamentos || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </IonLabel>
                            </div>


                          </IonCardContent>
                        </IonCard>
                      </IonCol>

                      <IonCol size="12" sizeMd="3">
                        <IonCard style={{ margin: "2px" }}

                        >

                          <IonCardContent>

                            <div style={{ fontSize: "14px" }}>
                              <IonLabel className="ion-text-wrap">
                                <b>Dinheiro</b>
                              </IonLabel>
                            </div>


                            <div style={{ fontSize: "20px" }}>
                              <IonLabel className="ion-text-wrap">
                                {"R$ " + Number((stateDinheiro + stateCaixaSelecionado.abertura + stateSaldoLancamentos) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </IonLabel>
                            </div>


                          </IonCardContent>
                        </IonCard>
                      </IonCol>







                    </IonRow>
                  </IonGrid>

                  <IonGrid>

                    {/* Botões principais */}
                    <IonRow>
                      <IonCol size="6" sizeMd="2">
                        <IonButton hidden={!(stateCaixaSelecionado.status == 'aberto')}
                          color='success'
                          expand='block'
                          disabled={acessos?.caixa != 'edicao'}
                          size='large'
                          onClick={() => {
                            setShowModalEntrada(true);
                          }}
                        >
                          + Entrada
                        </IonButton>
                      </IonCol>

                      <IonCol size="6" sizeMd="2">
                        <IonButton hidden={!(stateCaixaSelecionado.status == 'aberto')}
                          color='warning'
                          expand='block'
                          disabled={acessos?.caixa != 'edicao'}
                          size='large'
                          onClick={() => {
                            setShowModalSaida(true);
                          }}
                        >
                          - Saída
                        </IonButton>
                      </IonCol>

                      <IonCol size="12" sizeMd="8">
                        <IonButton hidden={!(stateCaixaSelecionado.status == 'aberto')}
                          color='danger'
                          expand='block'
                          disabled={acessos?.caixa != 'edicao'}
                          size='large'
                          onClick={() => {
                            mensagemFecharCaixa();
                          }}
                        >
                          Fechar Caixa
                        </IonButton>
                      </IonCol>
                    </IonRow>
                  </IonGrid>

                  <IonItem lines='full' color='light'>
                    <IonLabel style={{ fontSize: "20px" }}>
                      Total por tipo de venda
                    </IonLabel>
                  </IonItem>
                  <div className='caixaGeralTabelaCaixa'>


                    <IonGrid className='lancamentos'>

                      <IonRow hidden={stateTotalBalcao == 0}>
                        <IonCol>Balcão</IonCol>
                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateTotalBalcao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateTotalMesa == 0}>
                        <IonCol>Mesa</IonCol>
                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateTotalMesa).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateTotalOrdens == 0}>
                        <IonCol>{(window.localStorage.getItem("servicoTipoPlural") || "Projetos")}</IonCol>
                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateTotalOrdens).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateTotalTotem == 0}>
                        <IonCol>Totem</IonCol>
                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateTotalTotem).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                    </IonGrid>

                  </div>

                  <IonItem lines='full' color='light'>
                    <IonLabel style={{ fontSize: "20px" }}>
                      Total por forma de pagamento
                    </IonLabel>
                  </IonItem>
                  <div className='caixaGeralTabelaCaixa'>
                    {/* <IonGrid className='lancamentos'>


                      <IonRow hidden={stateDinheiro == 0}>
                        <IonCol>Dinheiro</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateDinheiro).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateCartaoCredito == 0}>
                        <IonCol>Cartão de Crédito</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateCartaoCredito).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateCartaoDebito == 0}>
                        <IonCol>Cartão de Débito</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateCartaoDebito).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={statePix == 0}>
                        <IonCol>Pix</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(statePix).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateAlelo == 0}>
                        <IonCol>Alelo</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateAlelo).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateSodexo == 0}>
                        <IonCol>Sodexo</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateSodexo).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateValeAlimentacao == 0}>
                        <IonCol>Vale Alimentação</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateValeAlimentacao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateBoleto == 0}>
                        <IonCol>Boleto</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateBoleto).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateSemDefinicao == 0}>
                        <IonCol>Sem Definição</IonCol>
                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateSemDefinicao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                    </IonGrid> */}

                    <IonGrid className="lancamentos">
                      {Object.entries(statePagamentos).map(([nome, valor]) => (
                        valor > 0 && (
                          <IonRow key={nome}>
                            <IonCol>{nome}</IonCol>
                            <IonCol style={{ textAlign: "right" }}>
                              {"R$ " + Number(valor).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </IonCol>
                          </IonRow>
                        )
                      ))}
                    </IonGrid>

                  </div>
                </div>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonModal className="small-modal" isOpen={showModal} onDidDismiss={() => { setShowModal(false); }}>
          <CaixaGeralAbrir closeAction={closeModalSuccess} closeActionSimple={closeModal}></CaixaGeralAbrir>
        </IonModal>

        <IonModal isOpen={showModalDetalhes} onDidDismiss={() => { setShowModalDetalhes(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Detalhes</IonTitle>
              <IonButtons slot="start" onClick={() => setShowModalDetalhes(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList>
              {readListaDetalhes()}
            </IonList>
          </IonContent>
        </IonModal>

        <IonModal className="small-modal" isOpen={showModalEntrada} onDidDismiss={() => {
          setShowModalEntrada(false);
          setValorEntrada('');
          setDescricaoEntrada('');
          setAlertaValorEntrada(false);
          setAlertaDescricaoEntrada(false);
        }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Nova Entrada</IonTitle>
              <IonButtons slot="start" onClick={() => {
                setShowModalEntrada(false);
                setValorEntrada('');
                setDescricaoEntrada('');
                setAlertaValorEntrada(false);
                setAlertaDescricaoEntrada(false);
              }}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonItem lines="none">
              <IonLabel position="stacked">Descrição*</IonLabel>
              <IonInput
                placeholder="Digite a descrição"
                value={descricaoEntrada}
                onIonChange={(e) => {
                  setDescricaoEntrada(e.detail.value!);
                  setAlertaDescricaoEntrada(false);
                }}
              />
            </IonItem>

            <IonItem lines="none">
              <IonLabel position="stacked">Valor*</IonLabel>
              <IonInput
                type="tel"
                maxlength={14}
                placeholder="Digite o valor"
                value={valorEntrada}
                onKeyUp={onChangeValorEntrada}
              />
            </IonItem>

            <IonItem lines="none">
              <IonIcon hidden={!alertaValorEntrada && !alertaDescricaoEntrada} size="large" slot="start" icon={alertCircle} color="danger" />
              <IonLabel hidden={!alertaValorEntrada && !alertaDescricaoEntrada} color="danger" style={{ fontSize: "14px" }}>Campo obrigatório</IonLabel>
            </IonItem>
          </IonContent>
          <IonFooter className="ion-no-border">
            <IonToolbar>
              <IonButton expand="block" size='large' color="primary" onClick={salvarEntrada}>
                Salvar
              </IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>

        <IonModal className="small-modal" isOpen={showModalSaida} onDidDismiss={() => {
          setShowModalSaida(false);
          setValorSaida('');
          setDescricaoSaida('');
          setAlertaValorSaida(false);
          setAlertaDescricaoSaida(false);
        }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Nova Saída</IonTitle>
              <IonButtons slot="start" onClick={() => {
                setShowModalSaida(false);
                setValorSaida('');
                setDescricaoSaida('');
                setAlertaValorSaida(false);
                setAlertaDescricaoSaida(false);
              }}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonItem lines="none">
              <IonLabel position="stacked">Descrição*</IonLabel>
              <IonInput
                placeholder="Digite a descrição"
                value={descricaoSaida}
                onIonChange={(e) => {
                  setDescricaoSaida(e.detail.value!);
                  setAlertaDescricaoSaida(false);
                }}
              />
            </IonItem>

            <IonItem lines="none">
              <IonLabel position="stacked">Valor*</IonLabel>
              <IonInput
                type="tel"
                maxlength={14}
                placeholder="Digite o valor"
                value={valorSaida}
                onKeyUp={onChangeValorSaida}
              />
            </IonItem>

            <IonItem lines="none">
              <IonIcon hidden={!alertaValorSaida && !alertaDescricaoSaida} size="large" slot="start" icon={alertCircle} color="danger" />
              <IonLabel hidden={!alertaValorSaida && !alertaDescricaoSaida} color="danger" style={{ fontSize: "14px" }}>Campo obrigatório</IonLabel>
            </IonItem>
          </IonContent>
          <IonFooter className="ion-no-border">
            <IonToolbar>
              <IonButton expand="block" size='large' color="primary" onClick={salvarSaida}>
                Salvar
              </IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>

        <IonModal isOpen={showModalLancamentos} onDidDismiss={() => { setShowModalLancamentos(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Lançamentos</IonTitle>
              <IonButtons slot="start" onClick={() => setShowModalLancamentos(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonGrid style={{ padding: '0px', margin: '0px' }}>
              <IonRow>
                <IonCol size="12" sizeMd='4'>
                  <IonCard style={{ padding: '0px', margin: '0px' }}>
                    <IonCardContent>
                      <div style={{ fontSize: "14px" }}>
                        <IonLabel>
                          <b>Total de Entradas</b>
                        </IonLabel>
                      </div>
                      <div style={{ fontSize: "20px", marginTop: "8px" }}>
                        <IonLabel>
                          {"R$ " + stateLancamentos
                            .filter((l: any) => l.tipo === 'entrada')
                            .reduce((sum: number, l: any) => sum + Math.abs(l.valor), 0)
                            .toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </IonLabel>
                      </div>
                    </IonCardContent>
                  </IonCard>
                </IonCol>

                <IonCol size="12" sizeMd='4'>
                  <IonCard style={{ padding: '0px', margin: '0px' }}>
                    <IonCardContent>
                      <div style={{ fontSize: "14px" }}>
                        <IonLabel>
                          <b>Total de Saídas</b>
                        </IonLabel>
                      </div>
                      <div style={{ fontSize: "20px", marginTop: "8px" }}>
                        <IonLabel>
                          {"R$ " + stateLancamentos
                            .filter((l: any) => l.tipo === 'saida')
                            .reduce((sum: number, l: any) => sum + Math.abs(l.valor), 0)
                            .toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </IonLabel>
                      </div>
                    </IonCardContent>
                  </IonCard>
                </IonCol>

                <IonCol size="12" sizeMd='4'>
                  <IonCard style={{ padding: '0px', margin: '0px' }}>
                    <IonCardContent>
                      <div style={{ fontSize: "14px" }}>
                        <IonLabel>
                          <b>Saldo</b>
                        </IonLabel>
                      </div>
                      <div style={{ fontSize: "20px", marginTop: "8px" }}>
                        <IonLabel>
                          <b>{"R$ " + stateSaldoLancamentos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                        </IonLabel>
                      </div>
                    </IonCardContent>
                  </IonCard>
                </IonCol>
              </IonRow>
            </IonGrid>

            <IonItem lines='full' >
              <IonLabel>
                <b>Detalhes</b>
              </IonLabel>
            </IonItem>

            <IonList>
              {stateLancamentos.length === 0 ? (
                <IonItem>
                  <IonLabel className="ion-text-center" color="medium">
                    Nenhum lançamento registrado
                  </IonLabel>
                </IonItem>
              ) : (
                stateLancamentos.map((lancamento: any, index: number) => (
                  <IonItem key={`lancamento-detail-${index}`} lines="full">
                    <IonLabel>
                      <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
                        {lancamento.data ? new Date(lancamento.data).toLocaleString('pt-BR').replace(',', '') : ''}
                      </p>
                      <h3 style={{ margin: '4px 0' }}>{lancamento.descricao}</h3>

                      <p style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: lancamento.valor > 0 ? '#2dd36f' : '#eb445a' }}>
                        {lancamento.valor > 0 ? '+' : '-'} R$ {Math.abs(lancamento.valor).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </p>
                    </IonLabel>
                  </IonItem>
                ))
              )}
            </IonList>
          </IonContent>
        </IonModal>

      </IonContent>

      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />

      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />
    </IonPage>
  );
};

export default CaixaGeral;
